import { DeclaredDocumentsFormDataProps } from '../../../../../../components/Documents/DeclaredDocumentsCreate';
import {
  AdditionalDocumentFormDataProps,
  previewAdditionalDocument,
} from '../../../../../../components/Forms/Steps/AdditionalDocument';
import {
  ConfirmationOfApplication,
  ConfirmationOfApplicationFormDataProps,
} from '../../../../../../components/Forms/Steps/ConfirmationOfApplication';
import {
  PersonalAndPassportFormDataProps,
  previewPersonalAndPassportData,
} from '../../../../../../components/Forms/Steps/PersonalAndPassportData';
import {
  PlaceOfResidenceFormDataProps,
  previewPlaceOfResidence,
} from '../../../../../../components/Forms/Steps/PlaceOfResidence';
import { previewWeaponsData } from '../../../../../../components/Forms/Steps/WeaponsData';

import { TransitDocumentFormDataProps, previewTransitDocument } from './Step3';

interface Props {
  formData: {
    weaponType?: string;
  } & PlaceOfResidenceFormDataProps &
    DeclaredDocumentsFormDataProps &
    AdditionalDocumentFormDataProps &
    PersonalAndPassportFormDataProps &
    TransitDocumentFormDataProps &
    ConfirmationOfApplicationFormDataProps;
  handleInputChange: (name: string, value: unknown) => void;
}

const Step8: React.FC<Props> = ({ formData, handleInputChange }) => {
  return (
    <ConfirmationOfApplication
      formData={formData}
      handleInputChange={handleInputChange}
      accordionData={[
        previewWeaponsData({
          selectedWeapon: {
            weapon: formData.weaponType,
          },
        }),
        previewTransitDocument({ formData }),
        previewPersonalAndPassportData({ formData }),
        previewPlaceOfResidence({ formData }),
        previewAdditionalDocument({ formData }),
      ]}
    />
  );
};

export default Step8;
